import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppConstants } from '../core/app.constants';
import { BaseResponse, UserContext } from "../core/core.component";

@Injectable()
export class AuthenticationService
{
  constructor(private http: Http) { }
  
  login(username, password): Observable<UserContext> 
  {
      var url = environment.REST_SERVICE_BASE_URL + "/auth/login";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      var userCtx: UserContext = null;
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      let body = AppConstants.formUrlEncode({ 'username': username, 'password': password });
      return this.http.post(url, body, {headers: headers}).map((responseData) => responseData.json());
  }
  
  // cambio password senza autenticazione (password scaduta o da cambiare al primo accesso)
  changeExpiredPassword(username: string, oldPassword: string, newPassword: string): Observable<BaseResponse>
  {
      var url = environment.REST_SERVICE_BASE_URL + "/auth/password/expired";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      let body = AppConstants.formUrlEncode({ 'username': username, 'oldPassword': oldPassword, 'newPassword': newPassword });
      return this.http.post(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  // cambio password dell'utente autenticato
  changePassword(srmToken, oldPassword: string, newPassword: string): Observable<BaseResponse>
  {
      var url = environment.REST_SERVICE_BASE_URL + "/auth/password/change";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      let body = AppConstants.formUrlEncode({ 'oldPassword': oldPassword, 'newPassword': newPassword });
      return this.http.post(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  logout(srmToken): Observable<BaseResponse>
  {
      var url = environment.REST_SERVICE_BASE_URL + "/auth/logout";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      return this.http.post(url, {}, {headers: headers}).map((responseData) => responseData.json());
  } 

  embody(srmToken, id: string): Observable<UserContext> {
    var url = environment.REST_SERVICE_BASE_URL + "/auth/embody?id=" + id
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
  }

  deactivateEmbody(srmToken): Observable<UserContext> {
    var url = environment.REST_SERVICE_BASE_URL + "/auth/embody/deactivate"
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
  }

}


// WEBPACK FOOTER //
// ./src/app/service/authentication.service.ts